import {
  Popup,
} from 'antd-mobile'
import type { ProductAttribute } from '../../types'


interface IProps {
  visible: boolean
  attributes: ProductAttribute[]
  onCancel?: () => void
}

function ProductAttributePopup(props: IProps) {
  const { visible, onCancel } = props

  return (
    <Popup
      visible={visible}
      onMaskClick={onCancel}
      showCloseButton={true}
      onClose={onCancel}
    >
      <div style={{padding: '30px 24px', fontSize: 12}}>
        <div style={{fontSize: 12, overflowY: 'auto', maxHeight: '50vh'}}>
          {props.attributes.map((item, index) => (
            <div key={index} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0'}}>
              <div>{item.attributeNameTrans}</div>
              <div>{item.valueTrans}</div>
            </div>
          ))}
        </div>
      </div>
    </Popup>
  )
}

export default ProductAttributePopup
